import React from 'react';

const Blogs = () => {
    return (
        <div className=''>
            <h1 className='text-center text-3xl font-bold'>Coming Soon</h1>
        </div>
    );
};

export default Blogs;